import { render, staticRenderFns } from "./Configuracoes2.vue?vue&type=template&id=32c90cb9&scoped=true&"
import script from "./Configuracoes2.vue?vue&type=script&lang=js&"
export * from "./Configuracoes2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c90cb9",
  null
  
)

export default component.exports